export default "/images/infinity.svg?20fe0728c0e15e85ffe5033b3a32975a";